import '@/setSharedDependencies'; // set shared-lib dependencies

import * as dependencies from '@/dependencies';
import { sync } from 'vuex-router-sync';
import router from '@/router';
import store from '@/store';

import App from '@/App';
import './registerServiceWorker';

// Sync include the router state in the store
sync(store, router);

/* eslint-disable no-new */
const vueInstance = new dependencies.Vue({
    router: router,
    store: store,
    i18n: dependencies.i18n,
    render: h => h(App),
}).$mount('#app');

export { vueInstance, dependencies };

if (window && window.Cypress) {
    window.UPYIELD = {
        store,
    };
    window.appReady = true;
}
